const TIPOS_CERT = [
  {
    id: 'pfx',
    name: 'Fichero PFX',
    disabled: false
  },
  {
    id: 'srl',
    name: 'Número de serie',
    disabled: false
  },
  {
    id: 'usr',
    name: 'Usuario y contraseña',
    disabled: true
  }
]

export {
  TIPOS_CERT
}
